<div class="chat-container">
  @if (user) {
    <dx-chat
      [class.dx-chat-disabled]="aiAssistantService.isDisabled"
      [dataSource]="dataSource"
      [reloadOnChange]="false"
      [showAvatar]="false"
      [showDayHeaders]="false"
      [showUserName]="true"
      [user]="user"
      height="100%"
      [typingUsers]="(typingUsers$ | async) || []"
      [alerts]="(alerts$ | async) || []"
      (onMessageEntered)="onMessageEntered($event)"
      messageTemplate="messageTemplate"
    >
      <div *dxTemplate="let data of 'messageTemplate'; let i = index">
        <ng-container>
          @if (isToolMessage(data.message)) {
            <div
              class="tool-activity"
              [class.tool-executing]="isToolExecuting(data.message)"
              [class.tool-completed]="isToolCompleted(data.message)"
            >
              <span class="tool-icon material-symbols-outlined">
                {{ getToolIcon(data.message) }}
              </span>
              <span class="tool-text">{{
                getToolDisplayText(data.message)
              }}</span>
            </div>
          } @else {
            <div
              class="dx-chat-messagebubble-text"
              [innerHTML]="convertToHtml(data.message)"
            ></div>
          }
          @if (
            !isToolMessage(data.message) &&
            !(((typingUsers$ | async) || []).length > 0)
          ) {
            <div class="dx-bubble-button-container">
              <dx-button
                [icon]="copyButtonIcon"
                stylingMode="text"
                hint="Copy"
                i18n-hint="@@copyButtonHint"
                (onClick)="onCopyButtonClick(data.message)"
              >
              </dx-button>
              <dx-button
                icon="refresh"
                stylingMode="text"
                hint="Regenerate"
                i18n-hint="@@regenerateButtonHint"
                (onClick)="onRegenerateButtonClick()"
              >
              </dx-button>

              <div class="feedback-buttons">
                <button
                  (click)="giveFeedback(data.message, Feedback.ThumbsUp)"
                  [class.selected]="selectedFeedback === Feedback.ThumbsUp"
                  [disabled]="isFeedbackSelected()"
                >
                  {{ FeedbackMap[Feedback.ThumbsUp] }}
                </button>
                <button
                  (click)="giveFeedback(data.message, Feedback.ThumbsDown)"
                  [class.selected]="selectedFeedback === Feedback.ThumbsDown"
                  [disabled]="isFeedbackSelected()"
                >
                  {{ FeedbackMap[Feedback.ThumbsDown] }}
                </button>
              </div>
            </div>
          }
          @if (!isToolMessage(data.message) && hasFeedback(data)) {
            <div class="dx-bubble-button-container ng-start-inserted">
              <div class="feedback-buttons feedback-selection">
                <button disabled [class.selected]="true">
                  {{
                    FeedbackMap[
                      aiAssistantService.feedbackDictionary[data.message.id]
                    ]
                  }}
                </button>
              </div>
            </div>
          }
        </ng-container>
      </div>
    </dx-chat>
  }
</div>
